import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { GridColumn, GridLayout, GridRow } from '@hh.ru/magritte-ui';

import { CertScrollAnchors } from 'src/models/pages/cert';

import Item from 'src/pages/CertLanding/components/SectionQuestions/Item';

import styles from './styles.less';

const TrlKeys = {
    1: {
        title: 'career-platform.page-cert-landing.section.questions.item.1.title',
        description: 'career-platform.page-cert-landing.section.questions.item.1.description',
    },
    2: {
        title: 'career-platform.page-cert-landing.section.questions.item.2.title',
        description: 'career-platform.page-cert-landing.section.questions.item.2.description',
    },
    3: {
        title: 'career-platform.page-cert-landing.section.questions.item.3.title',
        description: 'career-platform.page-cert-landing.section.questions.item.3.description',
    },
    4: {
        title: 'career-platform.page-cert-landing.section.questions.item.4.title',
        descriptionParagraph1: 'career-platform.page-cert-landing.section.questions.item.4.description.1.paragraph',
        descriptionParagraph2: 'career-platform.page-cert-landing.section.questions.item.4.description.2.paragraph',
    },
};

const SectionQuestions: TranslatedComponent = ({ trls }) => {
    const description4 = [trls[TrlKeys['4'].descriptionParagraph1], trls[TrlKeys['4'].descriptionParagraph2]];

    return (
        <section id={CertScrollAnchors.Questions}>
            <GridLayout>
                <GridRow>
                    <GridColumn xs={0} s={0} m={0} xl={2} />
                    <GridColumn xs={4} s={8} m={12} xl={8}>
                        <h3 className={styles.title}>Вопросы и ответы</h3>
                        <ul className={styles.list}>
                            <Item title={trls[TrlKeys['3'].title]} description={trls[TrlKeys['3'].description]} />
                            <Item title={trls[TrlKeys['1'].title]} description={trls[TrlKeys['1'].description]} />
                            <Item title={trls[TrlKeys['2'].title]} description={trls[TrlKeys['2'].description]} />
                            <Item title={trls[TrlKeys['4'].title]} description={description4} />
                        </ul>
                    </GridColumn>
                </GridRow>
            </GridLayout>
        </section>
    );
};

export default translation(SectionQuestions);
